import React from "react";
import {Helmet} from "react-helmet-async";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import {Card, Container} from "react-bootstrap";

const PlanningKastenbouw = () => {
    return (
        <React.Fragment>
            <Helmet title="Planning kastenbouw"/>
            <Container fluid className="p-0">
                <Card>
                    <Card.Header>
                        <h3>Planning kastenbouw</h3>

                    </Card.Header>
                    <Card.Body>

                        <div style={{display: "none"}} className={"noShow576Plus showOn576 "}>
                            <p style={{textAlign: "center"}}>
                                Helaas! <br/>
                                Op telefoon werkt een iframe niet goed.
                                Als je de planning wilt zien kun je deze op een computer bekijken.
                            </p>
                        </div>
                        <div style={{height: "76vh"}}>
                            <iframe
                                src='https://plan.tomsplanner.com/embedded/?id=MxBAgLSBbvOauwkmdTQaYmTLnBtGcSBSNsBkFTaoWZIppTmvlF&zoom=9'
                                frameBorder="0"
                                height="100%"
                                width="100%"
                                title="Iframe voor planning kastenbouw"
                                className={"hideOn576"}
                            >
                                Het iframe werkt niet. Neem contact op met ict en zeg: "Het iframe bij
                                Planning kastenbouw werkt niet".
                            </iframe>
                        </div>
                    </Card.Body>
                </Card>
            </Container>
        </React.Fragment>
    )
};

export default PlanningKastenbouw;
